<template>
  <div style="width: 100%; min-height: 600px; height: auto; margin-top:5px; display: flex; justify-content: center;">
    <div class="container-fluid">
      <div class="row">
        <nav id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
          <div class="position-sticky pt-3 sidebar-sticky">
            <ul v-show="this.$store.state.me.id" class="nav flex-column">

              <li class="nav-item">
                <router-link class="nav-link" active-class="active" to="/MyInfomation/info">
                  <span data-feather="home" class="align-text-bottom" style="font-size: 14px;">个人信息</span>
                </router-link>
              </li>
              
              <li v-if="this.$store.state.me.id != 3" class="nav-item">
                <router-link class="nav-link" active-class="active" to="/MyInfomation/study">
                  <span data-feather="file" class="align-text-bottom" style="font-size: 14px;">已购课程</span>
                </router-link>
              </li>

              <li v-if="this.$store.state.me.id != 3" class="nav-item">
                <router-link class="nav-link" active-class="active" to="/MyInfomation/competeexpence">
                  <span data-feather="file" class="align-text-bottom" style="font-size: 14px;">比赛经历</span>
                </router-link>
              </li>

              <li v-if="this.$store.state.me.id == 3" class="nav-item">
                <router-link class="nav-link" active-class="active" to="/MyInfomation/manage">
                  <span data-feather="file" class="align-text-bottom" style="font-size: 14px;">管理</span>
                </router-link>
              </li>
            </ul>

          </div>
        </nav>
        <!-- 展示个人信息或者比赛经历 -->
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>

  import '@/assets/bootstrap-5.3.0-alpha1-examples/dashboard/dashboard.css'
  import '@/assets/bootstrap-5.3.0-alpha1-examples/dashboard/dashboard.rtl.css'
  /* 来展示个人信息页 */
  export default {
    data() {
      return {
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: '',
          clickwho:'1',
        }
      }
    },
    methods: {
      onSubmit() {
        console.log('submit!');
      }
    }
  }
</script>

<style scoped>
.image {
  margin-left: 60px; 
  margin-top: 25px; 
   box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  width: 255px; height: 310px; 
   display: flex;
   justify-content: center; 
  background-color: blue;
}
.info {
  margin-left: 30px; 
  margin-top: 25px; 
   box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); 
  width: 800px; 
  height: 400px; 
   display: flex;
   justify-content: center; 
  background-color: green;
}
</style>